module.exports = __webpack_public_path__ + "img/user.21ac0315.jpg";